/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type EnrolmentStatus from '@linc-technologies/linced-common/enums/enrolment-status';
import type StoreService from '@linc-technologies/linced-common/services/store';

// Proto: people.EnrolmentStub.
export default class EnrolmentStub extends Fragment {
  declare [Type]: 'people/enrolment-stub';

  // Services
  @service
  declare store: StoreService;

  @attr('string', { defaultValue: '' })
  declare enrolmentId: string;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @computed('schoolId')
  get school() {
    if (!isEmpty(this.schoolId)) {
      return this.store.findRecord('school', this.schoolId, {
        backgroundReload: false,
      });
    }
    return null;
  }

  @attr('number', { defaultValue: 0 })
  declare status: EnumValue<typeof EnrolmentStatus> | 0;
}
